// extracted by mini-css-extract-plugin
export default {"Image":"index_Image__MHW5e"};